<template>
  <div class="page  " style="min-height: 100vh;">
    <div class="container  inner-page">
      <div class="app-header">
        <router-link :to="{ name: 'Home' }"><img class="app-logo" src="../assets/logo2.png"/></router-link>
        <div class=" btn lgLink" @click="changeLG">
          <a>{{ this.$i18n.locale }}</a>
        </div>
      </div>

      <div v-if="displayThanks">
        <b> {{ $t('thanks.topText') }}</b
        ><br />
        <div v-if="picUrl" style="margin-top:1rem">
          <a :href="picUrl" target="_blank">
            <img :src="picUrl" class="result-pic" />
          </a>
        </div>

        <div style="margin-top:16px">
          <a :href="downloadUrl" class="btn" target="_blank" style="padding-right: 40px; ">
            <!-- <img :src='downloadIconUrl'> -->
            <span>{{ $t('thanks.download') }}</span>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" style="height:20px;fill:#ffffff;position: absolute;right: 10px;top: 11px;">
              <path
                d="M382.56 233.376C379.968 227.648 374.272 224 368 224h-64V16c0-8.832-7.168-16-16-16h-64c-8.832 0-16
                 7.168-16 16v208h-64c-6.272 0-11.968 3.68-14.56 9.376-2.624 5.728-1.6 12.416 2.528 17.152l112 128c3.04
                  3.488 7.424 5.472 12.032 5.472s8.992-2.016 12.032-5.472l112-128c4.16-4.704 5.12-11.424 2.528-17.152z"
              ></path>
              <path d="M432 352v96H80v-96H16v128c0 17.696 14.336 32 32 32h416c17.696 0 32-14.304 32-32V352h-64z"></path>
            </svg>
          </a>
        </div>

        <br />
        <div style="text-align:center" v-html="textHtml"></div>
      </div>
      <template v-else>
        <h1 class="title" style="" v-if="title">{{ title }}</h1>
        <h2 class="subtitle" style="text-align:left;font-size:1rem" v-if="subTitle">{{ subTitle }}</h2>
        <div class="form-panel">
          <div class="field">
            <div class="control">
              <input class="input" type="text" maxlength="200" :placeholder="$t('form.Lastname')" v-model="Lastname" />
            </div>
          </div>

          <div class="field">
            <div class="control">
              <input class="input" type="text" maxlength="200" :placeholder="$t('form.Firstname')" v-model="Firstname" />
            </div>
          </div>

          <div class="field">
            <div class="control ">
              <input class="input" type="email" :placeholder="$t('form.emailLabel')" v-model="email" />
            </div>
          </div>

          <div class="field ">
            <div class="control">
              <a class="btn" style="min-width: 100%;" v-bind:class="{ disabledBtn: processing }" @click="onSubmit">{{ $t('form.btnText') }}</a>
            </div>
          </div>
        </div>
      </template>
      <Footer ref="footer"></Footer>
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line import/no-extraneous-dependencies

import isEmail from 'validator/es/lib/isEmail';
import axios from 'axios';
import mobile from 'is-mobile';

const fbIcon = require('../assets/facebook-logo.svg');
const waIcon = require('../assets/whatsapp-logo.svg');

export default {
  name: 'Form',

  components: {},
  directives: {},

  data() {
    return {
      email: '',
      Firstname: '',
      Lastname: '',

      city: '',

      picUrl: this.$store.mediaUrl,
      downloadUrl: this.$store.downloadUrl,
      message: '',
      maxCharacters: 140,
      processing: false,
      displayThanks: false,
    };
  },

  computed: {
    whatsAppIconUrl() {
      return waIcon;
    },

    fbAppIconUrl() {
      return fbIcon;
    },

    shareUrl() {
      return this.$store.shareUrl;
    },

    textHtml() {
      return this.$i18n.t('thanks.text');
    },
    charactersRemaining() {
      return this.maxCharacters - this.message.length;
    },

    title() {
      const v = this.$i18n.t('form.title');

      if (v.length >= 0) {
        return v;
      }
      return null;
    },

    subTitle() {
      const v = this.$i18n.t('form.subtitle');

      if (v.length >= 0) {
        return v;
      }
      return null;
    },
  },

  methods: {
    onWhatsAppShare() {
      const shareUrlEncoded = encodeURIComponent(this.shareUrl);
      const isMobile = mobile({ tablet: true });
      const whatsappLinkUrl = `${isMobile ? 'whatsapp://send?' : 'https://web.whatsapp.com/send?'}text=${shareUrlEncoded}`;
      window.open(whatsappLinkUrl, '_blank');
    },

    onFacebookShare() {
      const shareUrlEncoded = encodeURIComponent(this.shareUrl);

      const fbUrl = `https://www.facebook.com/sharer/sharer.php?u=${shareUrlEncoded}`;
      const windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      const windowHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
      const popWidth = Math.min(800, 0.8 * windowWidth);
      const popHeight = Math.max(400, Math.min(600, 0.8 * windowHeight));

      // eslint-disable-next-line max-len
      const popupProps = `height=${popHeight},left=${(windowWidth - popWidth) / 2},
      top=${(windowHeight - popHeight) / 2},width=${popWidth},status=1,toolbar=0`;

      if (!window.pr_mobile) {
        window.open(fbUrl, '', popupProps);
      } else {
        window.open(fbUrl, '_blank');
      }
    },

    displayAlert(message) {
      this.$swal({
        text: message,
      });
    },

    changeLG(e) {
      e.preventDefault();
      e.stopPropagation();

      const lg = this.$i18n.t('home.languageSwitchLocale');
      console.log('Switch language', lg);
      // eslint-disable-next-line no-undef
      this.$i18n.locale = lg;
    },

    async onSubmit() {
      if (this.Lastname.length <= 0) {
        // eslint-disable-next-line no-alert
        this.displayAlert(this.$i18n.t('form.LastnameInvalid')); // 'Please fill in your name'
        return;
      }

      if (this.Firstname.length <= 0) {
        // eslint-disable-next-line no-alert
        this.displayAlert(this.$i18n.t('form.FirstnameInvalid')); // 'Please fill in your name'
        return;
      }

      if (!isEmail(this.email)) {
        // eslint-disable-next-line no-alert
        this.displayAlert(this.$i18n.t('form.emailInvalid'));
        return;
      }

      const opti1Res = await this.$swal({
        title: '',
        text: this.$i18n.t('form.optinText1'),
        showCancelButton: true,
        confirmButtonText: this.$i18n.t('form.optinYes'),
        cancelButtonText: this.$i18n.t('form.optinNo'),
        reverseButtons: true,
        allowOutsideClick: false,
        allowEscapeKey: false,
      });

      const optin = opti1Res.value || false;

      if (this.processing) {
        return;
      }

      this.processing = true;

      const formData = {
        Lastname: this.Lastname,
        Firstname: this.Firstname,

        lg: this.$i18n.locale,
        email: this.email,
        optin,
        emailTemplate2: this.$i18n.t('form.emailTemplate') === '2',
        message: this.message,
        slideshow: optin,
      };

      const slideshow = optin;

      const postData = async (captchaToken) => {
        try {
          /*
           const upData = new FormData();

          upData.append('layout', this.$store.layoutId);
          upData.append('form', JSON.stringify(formData));
          upData.append('slideshow', `${slideshow}`);

          // eslint-disable-next-line max-len
          await axios.post(
            `/api/media/${this.$store.mediaId}/print`,

            upData,
            {
              headers: {
                token: captchaToken,
                'event-id': this.$store.eventId,
              },
            },
          ); */

          await axios.post(
            `/api/media/${this.$store.mediaId}/form`,

            {
              form: formData,
              slideshow,
            },
            {
              headers: {
                token: captchaToken,
                'event-id': this.$store.eventId,
              },
            },
          );
          window.scroll(0, 0);
          this.picUrl = this.$store.mediaUrl;
          this.displayThanks = true;
        } catch (err) {
          this.$swal({
            icon: 'error',
            title: 'Oops...',
            text: 'Sorry, something went wrong.',
          });
          console.log(err);
        } finally {
          this.processing = false;
        }
      };

      const self = this;
      window.grecaptcha.ready(() => {
        // eslint-disable-next-line no-underscore-dangle
        window.grecaptcha.execute(window._captchaId, { action: 'mediaform' }).then(
          (token) => {
            postData(token);
          },
          (reason) => {
            console.error('Captcha failure:', reason);

            self.$swal({
              icon: 'error',
              title: 'Oops...',
              text: 'Sorry, something went wrong.\nPlease check your internet connection?',
            });

            this.processing = false;
          },
        );
      });
    },
  },

  mounted() {
    if (!this.$store.mediaId) {
      this.$router.replace({ name: 'Themes' });
    }
  },
};
</script>

<style scoped>
.disabledBtn {
  opacity: 0.5;
}

.result-pic {
  max-width: 300px;
  height: auto;
  border-radius: 8px;
}
.form-panel {
  /*  max-width: 400px;*/
  margin: 0 auto;
}

.sharePanel {
  border-radius: 6px;
  margin: 0.5em 0 1em 0;
}

.downloadLink {
  text-decoration: underline;
  cursor: pointer;
}

.downloadLink img {
  height: 24px;
  width: auto;
  margin-right: 0.4em;
  display: inline-block;
  vertical-align: top;
}

.downloadLink span {
  line-height: 24px;
}

.whatsappLink,
.facebookLink {
  display: inline-block;

  border-radius: 6px;
  padding: 0.6em;
  margin: 0 0.6em;

  background: none;
  border: 1px solid #fff;
}

.whatsappLink {
}
.facebookLink {
}

.whatsappLink img,
.facebookLink img {
  height: 40px;
  vertical-align: top;

  display: inline-block;
}
</style>
